// extracted by mini-css-extract-plugin
export const visibleMediumUp = "AccountsDetailsHeader__visibleMediumUp__HHU-u";